
import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "@/components/ui/sheet";

const Navigation = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 100);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navItems = [
    { name: "Accueil", href: "#hero" },
    { name: "Projets", href: "#projects" }, 
    { name: "Contact", href: "#contact" },
  ];

  const scrollToSection = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    setIsOpen(false);
  };

  return (
    <nav className="fixed top-0 right-0 z-50">
      <Sheet open={isOpen} onOpenChange={setIsOpen}>
        <SheetTrigger asChild>
          <div 
            className={`
              fixed bg-black cursor-pointer hover:bg-gray-800 transition-all duration-500 ease-in-out
              ${isScrolled 
                ? 'top-0 right-0 rounded-full w-16 h-16 translate-x-[-1rem] translate-y-4' 
                : 'top-0 right-0 rounded-b-[3rem] px-6 py-6 translate-x-[-1.5rem] translate-y-0'
              }
            `}
          >
            <div className={`flex ${isScrolled ? 'items-center justify-center h-full' : 'justify-end'}`}>
              {/* Menu Burger */}
              <div className="flex flex-col items-center justify-center w-4 h-4">
                <div className="w-7 h-1 bg-white rounded-full mb-1"></div>
                <div className="w-7 h-1 bg-white rounded-full"></div>
              </div>
            </div>
          </div>
        </SheetTrigger>
        
        <SheetContent 
          side="right" 
          className="w-96 bg-white border-l-0 shadow-2xl"
        >
          <SheetHeader className="pb-8">
            <SheetTitle className="text-2xl font-black text-foreground text-left">
              Menu
            </SheetTitle>
          </SheetHeader>
          
          <div className="flex flex-col space-y-6">
            {navItems.map((item, index) => (
              <button
                key={item.name}
                onClick={() => scrollToSection(item.href)}
                className="group text-left py-4 px-0 border-b border-gray-100 last:border-b-0 transition-all duration-300"
              >
                <div className="flex items-center justify-between">
                  <span className="text-xl font-bold text-foreground group-hover:text-accent transition-colors duration-300">
                    {item.name}
                  </span>
                  <div className="w-2 h-2 rounded-full opacity-0 group-hover:opacity-100 transition-all duration-300 transform translate-x-2 group-hover:translate-x-0"
                       style={{
                         backgroundColor: index === 0 ? 'hsl(var(--pink))' : 
                                            index === 1 ? 'hsl(var(--accent))' : 
                                            'hsl(var(--success))'
                       }}></div>
                </div>
              </button>
            ))}
          </div>
          
          {/* Décoration */}
          <div className="absolute bottom-8 left-8 right-8">
            <div className="flex justify-center space-x-3">
              <div className="w-3 h-3 rounded-full bg-pink"></div>
              <div className="w-3 h-3 rounded-full bg-accent"></div>
              <div className="w-3 h-3 rounded-full bg-success"></div>
            </div>
          </div>
        </SheetContent>
      </Sheet>
    </nav>
  );
};

export default Navigation;
